export default () => {
    const incomingParams = localStorage.getItem('ss_incoming_params');

    if (!incomingParams) {
        return undefined;
    }

    try {
        const appsflyerParamsHistory = JSON.parse(incomingParams);
        return appsflyerParamsHistory?.find((param) => param?.campaign);
    } catch (error) {
        return undefined;
    }
};
